import addMount from "../../core/addMount";
import DashBoard from "./dashboard.entry";

addMount({ appName: "DashBoard", app: DashBoard });
